import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import HeadTitle from 'src/components/atoms/HeadTitle'
import MemberCard from 'src/components/molecules/MemberCard'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'

import Member1 from 'src/images/top/team/member1.png'
import Member2 from 'src/images/top/team/member2.png'
import Member3 from 'src/images/top/team/member3.png'
import { Typography } from 'src/components/atoms/Typography'

const TEAM = [
  {
    image: Member1,
    name: '岩熊勇斗',
    position: '執行役員CRO',
    description:
      '新卒でDeNAを経て、創業期のクラウドサイン(弁護士ドットコム)に入社。カスタマーサクセス部門の立ち上げおよび責任者を経験し、約5年間で10万社以上の顧客を支援。2020年よりコミューンに参画し、カスタマーサクセス部門責任者として従事したのち執行役員CROに就任。幅広い業種・業界におけるカスタマーサクセスの知見を有する。'
  },
  {
    image: Member2,
    name: '高原颯起',
    position: 'カスタマーサクセス部長',
    description:
      '新卒入社のAdtech企業でデジタルマーケティング領域のコンサルティング業務に従事し、ToB SaaSのCS責任者を務めた後2020年よりコミューンに参画。コミューンではCSMチームのマネージャーを経て、現在はCS部門の責任者を務める。BtoB・BtoC問わず幅広い業種・業界におけるカスタマーサクセス、コミュニティの知見を有する。'
  },
  {
    image: Member3,
    name: '須藤美幸',
    position: 'カスタマーサクセス(CSM)',
    description:
      'デジタルホールディングスのグループ会社に新卒入社。Web広告運用事業とデジマ教育事業を経験。その後、HR系スタートアップのカスタマーサクセスとして、採用制度設計のコンサルティングを行う。コミュニティマネージャーを担当し、イベント立ち上げやコミュニティ組成の経験を持つ。'
  }
]

const TopTeam = () => {
  return (
    <Container>
      <ContentsWrapper>
        <Contents>
          <HeadingBorder heading="TEAMS" />
          <HeadTitle as="h2">カスタマーサクセスに至るチーム体制</HeadTitle>
          <Description css={descriptionCss}>
            貴社・エンドユーザー双方にとって最適なプラットフォーム運営に対し、経験豊富なカスタマーサクセスが真摯に向き合い続けます
          </Description>
          <Team>
            {TEAM.map((member, i) => (
              <MemberCard {...member} key={i} />
            ))}
          </Team>
        </Contents>
      </ContentsWrapper>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  padding: 120px 0;
  background-color: ${Styles.color.primary[200]};

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    padding: 48px 0;
  }
`

const Contents = styled.div``

const Description = styled(Typography)`
  font-size: 14px;
  line-height: 28px;
  color: #333;
  letter-spacing: 0.07em;
`

const descriptionCss = css`
  margin-top: 8px;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin-top: 16px;
  }
`

const Team = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 64px;

  & > * + * {
    margin: 0 0 0 16px;

    @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
      margin: 24px 0 0;
    }
  }

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    flex-direction: column;
    margin-top: 48px;
  }
`

export default TopTeam
